var map = {
	"./ADVENTURE.svg": "e81e",
	"./ERRAND.svg": "1dc5",
	"./FOOD.svg": "565f",
	"./OTHER.svg": "e80d",
	"./SIGHTSEEING.svg": "3a31",
	"./STAY.svg": "49cc",
	"./TRAVEL.svg": "7c03",
	"./WELLNESS.svg": "04ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b8a8";